module.exports = __webpack_public_path__ + "img/frame (251).87c9a83f.jpg";